export default "__VITE_ASSET__B5_lYNTA__"